import { Component, OnInit, signal, WritableSignal, inject } from '@angular/core';
import { HeaderNavComponent } from '../../../../../shared/components/header-nav/header-nav.component';
import { HelpBtnComponent } from '../../../../../shared/components/help-btn/help-btn.component';
import { PaysCheckboxComponent } from '../../../../../shared/components/forms/pays-checkbox/pays-checkbox.component';
import { environment } from '../../../../../../environments/environment.dev';
import { UpdatePageTitle } from '../../../../../store/app/app.actions';
import { Store } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { DirectorApprovalDetail } from '../../../../../_interfaces/director-approval.interface';
import { BusinessApiService } from '../../../../../_services/business-service/business-api.service';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-banking-details-authorisation',
  imports: [HeaderNavComponent, HelpBtnComponent, PaysCheckboxComponent, LoaderComponent],
  templateUrl: './banking-details-authorisation.component.html',
})
export class BankingDetailsAuthorisationComponent implements OnInit {
  readonly store = inject(Store);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly businessApiService = inject(BusinessApiService);
  readonly toastService = inject(ToastService);

  protected chkBoxValue: boolean = false;
  protected company!: string;
  protected director!: string;
  protected requester!: string;
  protected tokenError: string | undefined;
  protected alreadyResponded: boolean | undefined;
  readonly token: string | null;
  protected label!: string;
  protected webUrl: string = environment.websiteBaseUrl;

  invalid: WritableSignal<boolean> = signal(false);
  submitted: WritableSignal<boolean> = signal(false);
  declined: WritableSignal<boolean> = signal(false);

  constructor() {
    this.token = this.route.snapshot.paramMap.get('token');
    this.store.dispatch(new UpdatePageTitle('Directors Authorisation'));
  }

  ngOnInit(): void {
    if (this.token) {
      this.businessApiService.approvalInfo(this.token).subscribe({
        next: (data: DirectorApprovalDetail) => {
          this.company = data.biz;
          this.requester = data.admin;
          if (data.approver) this.director = data.approver;
          this.label = `I hereby agree that I${this.director ? ', ' + this.director : ''} am a director of ${this.company} and authorise ${this.requester} to update ${this.company}'s banking information.`;
        },
        error: (err) => {
          this.invalid.set(true);
          this.tokenError = err.tokenError?.token ?? 'The authorisation token is invalid';
          this.alreadyResponded = err.error.non_field_errors[0] === 'Invalid approval object status';
        },
      });
    }
  }

  protected onSubmit() {
    if (this.token) {
      return this.businessApiService.approveBankingDetails(this.token).subscribe({
        next: () => {
          this.submitted.set(true);
        },
        error: () => {
          this.toastService.show('An error has occurred', 'iconoir-xmark');
        },
      });
    }
    return undefined;
  }

  protected onDecline() {
    if (this.token) {
      return this.businessApiService.declineBankingDetails(this.token).subscribe({
        next: () => {
          this.submitted.set(true);
          this.declined.set(true);
          window.location.href = this.webUrl;
        },
        error: () => {
          this.toastService.show('An error has occurred', 'iconoir-xmark');
        },
      });
    }
    return undefined;
  }

  protected onClose() {
    window.location.href = this.webUrl;
  }
}
